<script setup>
/**
 * Reusable component for ClinicDisplay and ClinicUpload
 */
import { reactive } from 'vue';
import { formatDate, pushDate } from '@/libraries/DateFunctions.js';

const emits = defineEmits(['setDate']); // emits date as object
const props = defineProps(['text', 'initialDate']);

const state = reactive({
  date: formatDate(new Date()), // data as yyyy-mm-dd
  text: props.text,
});


init();

function init() {
  if (props.initialDate) {
    state.date = formatDate(props.initialDate);
  }
}

function onDateChange() {
  const d = pushDate(state.date, 1); // dates are retarded and need to be pushed forward one day
  emits('setDate', d);
}
</script>

<template>
    <h2 class="clinic-date">{{state.text}} <input type="date" v-model="state.date" @change="onDateChange()"></h2>
</template>

<style scoped lang="scss">
.clinic-date {
    background-color: #fff;
    padding: 1.25rem;
    border-radius: 1rem;
    text-align: center;
    margin: 1rem 0;
    border: 1px solid #ccc;
    border-top: 5px solid #673ab7;
    width: rem;

    h1, h2, h3 {
        display: inline;
    }
}
input[type="date"]{
  cursor: pointer;

}
</style>